'use client';

import { FC, PropsWithChildren } from 'react';

import { UserProfile, UserProvider as Auth0UserProvider } from '@auth0/nextjs-auth0/client';

import { User } from '../models/user.model';

import { AuthenticationContextProvider } from './authentication-context-provider';
import { NoopAuthenticationContextProvider } from './noop-authentication-context-provider';
import { TokenProvider } from './token-provider';

type AuthenticationProvidersProps = PropsWithChildren & {
   isPublic: boolean;
   defaultToken?: string | undefined;
   initialUser?: User;
};

export const AuthenticationProviders: FC<AuthenticationProvidersProps> = ({ isPublic, initialUser, defaultToken, children }) => {
   if (isPublic) {
      return <NoopAuthenticationContextProvider>{children}</NoopAuthenticationContextProvider>;
   }

   // HACK: since the first implementation of the auth didn't save the full user in the session cookie we need to check if it is available
   // if not we need to re-fetch the user
   if (initialUser && initialUser.groups === undefined) {
      initialUser = undefined;
      defaultToken = undefined;
   }

   return (
      <Auth0UserProvider user={initialUser as UserProfile | undefined}>
         <TokenProvider defaultToken={defaultToken}>
            <AuthenticationContextProvider>{children}</AuthenticationContextProvider>
         </TokenProvider>
      </Auth0UserProvider>
   );
};
